import { Switch } from "antd"
import { translations } from "../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const common_btn = translations[lang]?.common_btn

export const getBusinessActions = (
  setDeleteRequestORApproved,
  status,
  handleView,
  handleMerchantUpdate,
  handleDelete,
  handleDeleteMerchantModalOpen,
  updateLoading,
  handleUnblockRequest, // ✅ add this when calling getBusinessActions
  canDelete = true // false for `edit_only` roles: everything but delete
) => {
  if (status === "approved") {
    return [
      {
        switch: (row) => (
          <Switch
            checked={row.active_status}
            className="custom-switch mr-20"
            disabled={updateLoading[row.id]} // Disable switch when updating
            onChange={(status) => {
              if (!updateLoading[row.id]) {
                handleMerchantUpdate(row, status)
              }
            }}
          />
        ),
        type: "switch",
      },
      {
        icon: "/store/carbon_view.svg",
        className: "view",
        onClick: (row) => handleView(row),
        type: "image",
      },
      ...(canDelete
        ? [
            {
              icon: "/store/trash.svg",
              className: "delete",
              onClick: (row) => {
                handleDeleteMerchantModalOpen(row)
                setDeleteRequestORApproved("approved")
              },
              type: "image",
            },
          ]
        : []),
    ]
  } else if (status === "pending") {
    return [
      {
        text: common_btn?.update,
        className: "view-add-comments",
        onClick: (row) => handleView(row),
        type: "text",
      },
    ]
  } else if (status === "blocked") {
    return [
      {
        icon: "/store/carbon_view.svg",
        className: "view",
        onClick: (row) => handleView(row),
        type: "image",
      },
      {
        icon: "/store/user-unlock-01.svg",
        className: "unblock",
        onClick: (row) => handleUnblockRequest(row), // ✅ dedicated unblock handler
        type: "image",
      },
      ...(canDelete
        ? [
            {
              icon: "/store/trash.svg",
              className: "delete",
              onClick: (row) => {
                handleDeleteMerchantModalOpen(row)
                setDeleteRequestORApproved("blocked") // ✅ fixed (was "approved")
              },
              type: "image",
            },
          ]
        : []),
    ]
  } else {
    return [
      {
        icon: "/store/carbon_view.svg",
        className: "view",
        onClick: (row) => handleView(row),
        type: "image",
      },
      ...(canDelete
        ? [
            {
              icon: "/store/trash.svg",
              className: "delete",
              onClick: (row) => {
                handleDeleteMerchantModalOpen(row)
                setDeleteRequestORApproved("rejected")
              },
              type: "image",
            },
          ]
        : []),
    ]
  }
}

/** Read-only actions for market_role "2" (Business Viewer): View only, no switch/delete */
export const getBusinessActionsReadOnly = (handleView) => {
  return [
    {
      icon: "/store/carbon_view.svg",
      className: "view",
      onClick: (row) => handleView(row),
      type: "image",
    },
  ]
}
